<div [style.padding.px]="15">
    <form id="searchForm" (ngSubmit)="search()">
        <mat-form-field [style.width.%]="100">
            <input matInput placeholder="Search for something" [(ngModel)]="searchText" name="searchText" type="text" />
        </mat-form-field>
        <!--<button type="submit" mat-button="">Search</button>-->
    </form>
    <sphere-search-result #searchResult></sphere-search-result>
</div>
